import { z } from 'zod/v4';

export const CreateOrderTagBodySchema = z.object({
  /**
   * The tag's name. Stored trimmed and lowercased; a name the company already
   * has answers the existing tag.
   */
  orderTag: z
    .string()
    .min(1)
    .refine(name => name.trim().length > 0, {
      message: 'orderTag must not be blank',
    }),
});

export type CreateOrderTagBody = z.infer<typeof CreateOrderTagBodySchema>;

/** One entry of a company's order-tag catalogue (`tracing_order_tags`). */
export const OrderTagSchema = z.object({
  id: z.string(),
  /** The stored, normalized name. */
  orderTag: z.string(),
});

export type OrderTag = z.infer<typeof OrderTagSchema>;

/** Wire shape: the standard `reply.apiSuccess` envelope around the tag. */
export const CreateOrderTagResponseSchema = z.object({
  metadata: z.object({ success: z.literal(true) }),
  data: OrderTagSchema,
});

export type CreateOrderTagResponse = z.infer<
  typeof CreateOrderTagResponseSchema
>;

/** Wire shape: the whole catalogue, newest first, in the standard envelope. */
export const ListOrderTagsResponseSchema = z.object({
  metadata: z.object({ success: z.literal(true) }),
  data: z.array(OrderTagSchema),
});

export type ListOrderTagsResponse = z.infer<typeof ListOrderTagsResponseSchema>;
